module.exports = __webpack_public_path__ + "img/IchBinDannMalWeg.70aa45cb.jpg";